// extracted by mini-css-extract-plugin
module.exports = {"container":"ValueBox_container__C1gZl","text":"ValueBox_text__IoAR3","removeButton":"ValueBox_removeButton__3aNGx"};